import FingerprintJS from '@fingerprintjs/fingerprintjs';

// Lazy-load fingerprintjs and cache it in localStorage
export async function getDeviceFingerprint() {
    // Check if we already saved a local UUID
    let localUuid = localStorage.getItem('fp_local_uuid');
    if (!localUuid) {
        localUuid = crypto.randomUUID();
        localStorage.setItem('fp_local_uuid', localUuid);
    }

    // Get raw FPJS fingerprint
    const fp = await FingerprintJS.load();
    const result = await fp.get();

    // Combine fingerprint with your own stable per-browser UUID
    const combined = result.visitorId + ':' + localUuid;

    // Hash it for consistency
    const fingerprint = await digestSHA256(combined);

    return fingerprint;
}

async function digestSHA256(input) {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hash = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hash))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
}